import axios from 'axios';
import { Auth } from 'aws-amplify';

const NOTIFIED_ERRORS_KEY = 'ui_errors_notified';

const getNotifiedErrors = (): string[] => {
  try {
    return JSON.parse(sessionStorage.getItem(NOTIFIED_ERRORS_KEY) || '[]');
  } catch {
    return [];
  }
};

const sendUIErrorNotification = async (errorDetails: {
  errorMessage: string;
  componentStack?: string;
  page: string;
}) => {
  const errorKey = `${errorDetails.page}|${errorDetails.errorMessage}`;
  const notified = getNotifiedErrors();
  if (notified.includes(errorKey)) return;
  sessionStorage.setItem(NOTIFIED_ERRORS_KEY, JSON.stringify([...notified, errorKey]));

  try {
    const userSession = await Auth.currentSession();
    const user = userSession.getIdToken().payload;

    await axios.post(
      `${process.env.REACT_APP_BASE_API_GATEWAY_URL}/ui-error-notify`,
      {
        errorType: 'FRONTEND_ERROR',
        userEmail: user?.email || 'unknown',
        page: errorDetails.page,
        message: errorDetails.errorMessage,
        componentStack: errorDetails.componentStack || 'N/A',
        timestamp: new Date().toISOString(),
      }
    );
  } catch (notifyErr) {
    console.warn('Failed to send UI error notification', notifyErr);
  }
};

export default sendUIErrorNotification;
